<template>
  <tr class="detail">
    <td :colspan="currentIdc.locationCode == 'N2CDT014070' ? 12 : 11">
      <h4>상세정보</h4>
      <div class="result-tbl m-t-sm">
        <table class="tbl">
          <tbody>

          <tr>
            <!--<col-field  label="티켓 번호" icon="icon-move-link">-->
              <!--<Input :value="ticket" placeholder="티켓 번호" :style="item.visitor.ntreeTicket ? 'cursor:pointer;' : ''"/>-->
            <!--</col-field>-->
            <th>티켓 번호 <i class="icon-move-link"></i></th>
            <td>
              <span v-if="item.visitor.ntreeTicket" style="cursor:pointer;color:#187ed6;" @click="goNtreeTicket(item.visitor.ntreeTicket)"> {{ticket}}</span>
              <span v-if="!item.visitor.ntreeTicket" > {{ticket}}</span>
            </td>
            <th>IDC</th>
            <td>{{item.visitor.visitIdc.locationName}}</span></td>
          </tr>
          <tr>
            <th>출입요청 기간</th>
            <td>{{getDueDate(item.visitor.fromDate, item.visitor.toDate)}}</td>
            <th>예약 시간</th>
            <td>{{getDate(item.visitor.reservationTimestamp)}}</td>
          </tr>
          <tr>
            <col-field  label="이름">
              <Input :value="item.visitor.visitorName" placeholder="이름"/>
            </col-field>
            <col-field  label="회사명">
              <Input :value="item.visitor.visitorCompany" placeholder="회사명"/>
            </col-field>
          </tr>
          <tr>
            <col-field  label="담당자">
              <Input :value="item.visitor.empName" placeholder="담당자"/>
            </col-field>
            <th>방문목적</th>
            <td>{{getCodeByKey('visitType', 'visitTypeCode', item.visitor.visitTypeCode).visitTypeStr}}
            </td>
          </tr>
          <tr>
            <th>예약 타입</th>
            <td>{{item.visitor.reservationType}}</td>
            <th>신청자/동행자</th>
            <td>{{item.visitor.isApplicant == 1 ? '신청자':'동행자'}}
            </td>
          </tr>
          <tr>
            <th>서명 동의</th>
            <td><p v-for="tos in item.visitor.tosList">{{tos.tos.tosTitle + " (" + getDate(tos.agreeTimestamp)+")"}}</p></td>
            <th></th>
            <td></td>
          </tr>
        </tbody></table>
      </div>
      <div class="result-tbl" v-if="item.checkInTimestamp">
        <table class="tbl">
          <tbody>
          <tr>
            <th>입실 시간</th>
            <td>{{getDate(item.checkInTimestamp)}}</td>
            <th>퇴실 시간</th>
            <td>{{getDate(item.checkOutTimestamp)}}</td>
          </tr>
          <tr>
            <col-field  label="칸 번호" :editMode="item.visitor.statusCode == 6 && item.visitor.reservationType != '상주직원' ? true : false ">
              <Input v-model="item.spaceNumber" placeholder="칸 번호" @confirmInput="update()"/>
            </col-field>
            <col-field  label="카드 번호" :editMode="item.visitor.statusCode == 6 ? true : false ">
              <Input v-model="item.cardNumber" placeholder="카드 번호" @confirmInput="update()"/>
            </col-field>
          </tr>
          <tr>
            <col-field  label="인솔자" :editMode="false">
              <Input v-model="item.accompanyEmpName" placeholder="인솔자" @confirmInput="update()"/>
            </col-field>
            <th>
            </th>
            <td>
            </td>
          </tr>
          <tr>
            <col-field  label="입실처리자" :editMode="false">
              <Input v-model="item.checkInEmployeeName" placeholder="입실처리자" @confirmInput="update()"/>
            </col-field>
            <col-field  label="퇴실처리자" :editMode="false">
              <Input v-model="item.checkOutEmployeeName" placeholder="퇴실처리자" @confirmInput="update()"/>
            </col-field>
          </tr>
          <tr>
            <th>카드 반납 여부</th>
            <td>{{item.isReturnCard == 1 ? '반납':'미반납'}}</td>
            <th></th>
            <td></td>
          </tr>
        </tbody></table>
      </div>

      <div class="result-tbl" v-if="item.visitor.reservationType != '상주직원'">
        <table class="tbl">
          <tbody>
          <tr>
            <col-field  label="출입위치" :editMode="item.visitor.statusCode == 6 ? true : false ">
              <td>
                <LocationList ref="locationList" :reservedLocationList="JSON.parse(item.visitor.visitLocation)" @confirmInput="update()" :border="false" :idcCode="item.visitor.visitIdcCode" :checkedLocationList="JSON.parse(item.locationList)"/>
              </td>
            </col-field>

            <th>화물 E/V 사용 위치</th>
            <td>
              <div class="box border-box" style="border: none;">
                <div class="scroll-wrap" ui-jp="mCustomScrollbar" data-mcs-theme="minimal-dark" ui-options="{theme:'minimal-dark', height: '200px'}" style="max-height: 170px; height: 170px; overflow-y: scroll">
                  <div class="box-body" style="padding: 0px 0px">
                    <div v-for="(item, index) in commaToArr(item.visitor.evLocation)" style="color: #333">
                      <label class="md-check" style="padding-left: 0px;">
                        <span><i class="icon-sequence" style="color: #00c73d; margin-right: 5px"></i>{{item}}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <col-field  label="반입자산" :editMode="item.visitor.statusCode == 6 ? true : false ">
              <AssetList :isDetail="true" ref="assetList" :value="item.visitor.assetList" @confirmInput="update()" :border="false"/>
            </col-field>
          </tr>
        </tbody></table>
      </div>

      <div class="result-tbl">
        <table class="tbl">
          <tbody>
          <tr>
            <th>차량 정보</th>
            <td>{{item.visitor.carModel ? item.visitor.carModel : ''}} {{' '}} {{item.visitor.carNumber ? item.visitor.carNumber : ''}}</td>
            <th></th>
            <td></td>
          </tr>
          <tr>
            <col-field  label="메모" :editMode="item.visitor.statusCode == 6 ? true : false">
              <TextArea class="form-control" v-model="item.memo" placeholder="메모" style="width:100%" @confirmInput="update()"/>
            </col-field>
            <th></th>
            <td></td>
            <!--<col-field  label="카드 번호" :editMode="item.visitor.statusCode == 6 ? true : false ">-->
              <!--<Input v-model="item.cardNumber" placeholder="카드 번호" @confirmInput="update()"/>-->
            <!--</col-field>-->
          </tr>
        </tbody>
        </table>
      </div>
    </td>
  </tr>
</template>

<script>
import ColField from '@/components/ColField.vue';
import RowField from '@/components/RowField.vue';
import Input from "@/components/Input.vue"
import TextArea from "@/components/TextArea.vue"
import AssetList from './AssetList.vue';
import LocationList from './LocationList2.vue';
import LocationBase from '@/components/common/locationBase'

export default {
  mixins: [LocationBase],
  props: ['item'],
  components: {
    Input,
    ColField,
    RowField,
    AssetList,
    LocationList,
    TextArea
  },
  computed: {
    assetList(){
      var assetList = this.item.assetList;
      var visitorAssetList = this.item.visitor.assetList;
      return this.item.visitor.assetList;
    },
    getLocationSoruce(){
      return (location, chekedLocation) =>{
        var locationList = this.getParseLocation(location);
        var chekedLocationList = this.getParseLocation(chekedLocation);
        locationList.forEach(x => {
          x.reserved = true;
          if(chekedLocationList.filter((y) => y.key == x.key).length > 0){

            x.checked = true;
          }
        });
        return locationList;
      }
    },
    ticket(){
      // return this.item.visitor.ntreeTicket == null ? this.item.visitor.reservationType : this.item.visitor.ntreeTicket
      return this.item.visitor.ntreeTicket == null ? '-' : this.item.visitor.ntreeTicket
    },
    currentIdc(){
      return this.$store.state.location.currentIdc;
    }
  },
  mounted(){
    console.log(this.item);
    this.init();
  },
  methods: {
    init(){
      var assetList = JSON.parse(this.item.assetList) || [];
      this.item.visitor.assetList.forEach(x=>{
        if(assetList.filter(z => z == x.visitorAssetIndex).length > 0){
          x.checked = true;
        }
      })
      this.$refs.assetList.$forceUpdate();
    },
    update() {
      var o = this.copyNew(this.item);

      console.log(this.$refs.locationList);
      if(this.$refs.locationList){
        o.locationList = this.$refs.locationList.selectedItems.map(x=>{
          return x.code;
        });
      }

      debugger;
      o.assetList = _.map(o.visitor.assetList.filter(x => x.checked), z=>{
        return z.visitorAssetIndex;
      });

      console.log(o);


      this.$http.put('/api/private/visitor/checkIn', o)
        .then((result) => {
          // this.$toast.success('입실정보가 수정되었습니다.');
          this.noti('완료', '입실 정보가 수정되었습니다.', 'success');
        }).catch((e) =>{
          console.log(e);
      })
    },
    goNtreeTicket(ticketNumber) {
      if(ticketNumber) {
        let url = `http://ntree.navercorp.com/staff/ticket/popup/${ticketNumber}.html`;
        window.open(url);
      }
    },
    commaToArr(str){
      if(str) return str.split(", ").sort();
      else null;
    }

  }
}
</script>

<style>

</style>
